// src/components/Home.jsx
import React, { useState, useEffect } from "react";
import "../styles/styles.css";
import { ReactComponent as PetfamLogo } from "../assets/PetfamLogo.svg";
import background from "../assets/BackgroundHome.webp"; // vet + puppy (hero)
import heroServicios from "../assets/hero-servicios.webp"; // usada en "Somos Petfam"
import { Link } from "react-router-dom";

/* =========================================================
   Iconos — trazos simples, coherentes con el resto del sitio
   ========================================================= */
const Icon = ({ children }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="22" height="22" aria-hidden="true">
    {children}
  </svg>
);
const IconPhone = () => <Icon><path d="M4 5c0-.6.4-1 1-1h2.4c.5 0 .9.3 1 .8l.8 3.2c.1.4 0 .8-.3 1.1L7.5 10.5a13 13 0 0 0 6 6l1.4-1.4c.3-.3.7-.4 1.1-.3l3.2.8c.5.1.8.5.8 1V19c0 .6-.4 1-1 1h-1C10.3 20 4 13.7 4 6V5Z"/></Icon>;
const IconBell = () => <Icon><path d="M12 3a5 5 0 0 0-5 5v3.3c0 .6-.2 1.2-.6 1.7L5 15h14l-1.4-2c-.4-.5-.6-1.1-.6-1.7V8a5 5 0 0 0-5-5Z"/><path d="M9.5 18a2.5 2.5 0 0 0 5 0"/></Icon>;
const IconVideo = () => <Icon><rect x="3" y="6.5" width="12" height="11" rx="2"/><path d="M15 10.5 21 7v10l-6-3.5"/></Icon>;
const IconFileHeart = () => <Icon><path d="M8 3h6l4 4v13a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/><path d="M12 17.5s-3-1.7-3-3.9a1.9 1.9 0 0 1 3-1.5 1.9 1.9 0 0 1 3 1.5c0 2.2-3 3.9-3 3.9Z"/></Icon>;
const IconCalendar = () => <Icon><rect x="3.5" y="5" width="17" height="15" rx="2"/><path d="M3.5 9.5h17M8 3v4M16 3v4"/><path d="M12 15.6s-2.2-1.2-2.2-2.8a1.4 1.4 0 0 1 2.2-1.1 1.4 1.4 0 0 1 2.2 1.1c0 1.6-2.2 2.8-2.2 2.8Z"/></Icon>;
const IconId = () => <Icon><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.5" cy="11" r="1.8"/><path d="M6 15.5c.5-1.3 1.5-2 2.5-2s2 .7 2.5 2M14 9.5h5M14 13h5M14 16h3"/></Icon>;
const IconUsers = () => <Icon><circle cx="9" cy="9" r="2.8"/><path d="M3.5 18c.7-2.6 2.8-4 5.5-4s4.8 1.4 5.5 4"/><circle cx="17" cy="9.5" r="2.2"/><path d="M15.5 12.2c1.9.4 3.3 1.6 4 3.8"/></Icon>;
const IconBook = () => <Icon><path d="M4 5.5c2-1 5-1 7 0v13c-2-1-5-1-7 0Z"/><path d="M20 5.5c-2-1-5-1-7 0v13c2-1 5-1 7 0Z"/></Icon>;
const IconShield = () => <Icon><path d="M12 3.5 5 6v5.5c0 5 3 8 7 9 4-1 7-4 7-9V6l-7-2.5Z"/><path d="m9 12 2 2 4-4.5"/></Icon>;
const IconPlus = ({ open }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" width="18" height="18" className={`pf-faq-icon ${open ? "is-open" : ""}`} aria-hidden="true">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

const Stars = () => (
  <div className="pf-stars" aria-label="5 estrellas">
    {Array.from({ length: 5 }).map((_, i) => (
      <svg key={i} viewBox="0 0 24 24" className="pf-star" aria-hidden="true">
        <path d="M12 17.27l-5.18 3.04 1.4-5.95-4.62-4 6.08-.52L12 4.5l2.32 5.34 6.08.52-4.62 4 1.4 5.95L12 17.27z" />
      </svg>
    ))}
  </div>
);

const Home = () => {
  const [navOpen, setNavOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState(-1);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [activeNav, setActiveNav] = useState("inicio");

  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  const isMobileOrTablet = windowWidth <= 1024;

  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleNavClick = (key) => {
    setActiveNav(key);
    setNavOpen(false);
    if (key === "inicio") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const formatCOP = (n) => n.toLocaleString("es-CO", { maximumFractionDigits: 0 });
  const PLAN_PRICE_COP = 19900;

  const planIncludes = [
    "Call Center 24/7 con veterinarios",
    "Etología virtual ilimitada",
    "Historia clínica digital",
    "Calendario y recordatorios",
    "Carnet digital por mascota",
    "Red de aliados con descuentos",
    "Contenido personalizado",
    "Urgencias",
  ];

  const services = [
    { icon: <IconPhone />, tone: "teal", title: "Call Center 24/7", text: "Habla con un veterinario real a cualquier hora, todos los días del año." },
    { icon: <IconBell />, tone: "peach", title: "Urgencias", text: "Atención de emergencias a domicilio o en clínicas cuando más lo necesitas." },
    { icon: <IconVideo />, tone: "dark", title: "Etología ilimitada", text: "Consultas virtuales sin límite con especialistas en comportamiento animal." },
    { icon: <IconFileHeart />, tone: "cream", title: "Historia clínica digital", text: "Todo el historial médico de tu mascota, disponible siempre y en un solo lugar." },
    { icon: <IconCalendar />, tone: "teal", title: "Calendario y recordatorios", text: "Vacunas, desparasitaciones y fechas importantes: nunca más se te olvida nada." },
    { icon: <IconId />, tone: "peach", title: "Carnet digital", text: "Un carnet único por mascota que puedes compartir con cualquier veterinario." },
    { icon: <IconUsers />, tone: "dark", title: "Red de aliados con descuentos", text: "Vacunas, peluquería, hoteles, microchips y desparasitaciones a precios preferenciales." },
    { icon: <IconBook />, tone: "cream", title: "Contenido personalizado", text: "Guías, tips y consejos según la especie, raza y edad de cada una de tus mascotas." },
  ];

  const testimonials = [
    { title: "Fácil de usar", quote: "La página es súper fácil. En minutos ya tenía todo listo y entendí el plan sin enredos.", who: "Laura M. · Usuaria Petfam" },
    { title: "Tratamiento efectivo", quote: "El medicamento formulado por el veterinario le quitó por completo la alergia de los ojos a Milo.", who: "Sebas R. · Papá de Milo" },
    { title: "Etólogo que sí funciona", quote: "El etólogo fue un cambio total: mi perrito dejó de tirar de la correa y está mucho más tranquilo en casa.", who: "Ana P. · Mamá de Bruno" },
    { title: "Soporte y acompañamiento", quote: "Sentí apoyo real cuando tuve dudas y no tuve que esperar días para una respuesta.", who: "María G. · Usuaria Petfam" },
    { title: "Todo organizado", quote: "Historial, recordatorios y seguimiento. Es como tener la vida de mi mascota en un solo lugar.", who: "Diego V. · Papá de Luna" },
    { title: "El auxilio nos salvó", quote: "Nala tuvo una urgencia y el auxilio económico cubrió lo que necesitábamos. Vale cada peso.", who: "Camila T. · Mamá de Nala" },
  ];

  useEffect(() => {
    if (!isMobileOrTablet) return;
    const id = setInterval(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 3500);
    return () => clearInterval(id);
  }, [isMobileOrTablet, testimonials.length]);

  const faqs = [
    {
      q: "¿Qué incluye la suscripción de $19.900?",
      a: "Call center 24/7 con veterinarios, consultas virtuales ilimitadas de etología, historia clínica digital, calendario de recordatorios, carnet digital, red de aliados con descuentos y auxilio económico de $800.000 COP por evento sin límite de eventos.",
    },
    {
      q: "¿Cuántas mascotas puedo registrar por perfil?",
      a: "Cada perfil incluye hasta 2 mascotas. Si tienes más, debes crear una cuenta adicional.",
    },
    {
      q: "¿Cómo funciona el auxilio económico de $800.000?",
      a: "Ante una urgencia, accidente o enfermedad cubrimos hasta $800.000 COP por evento, sin límite de eventos al año. Se activa desde el segundo mes de tu suscripción. Ejemplo real: tu mascota se lastima la pata y el veterinario indica que necesita una radiografía y un tratamiento. Supongamos que el total de los gastos es de $1.000.000 COP, el auxilio cubre hasta $800.000 COP de los gastos de la clínica, tú solo pagas la diferencia de $200.000 COP.",
    },
    {
      q: "¿Atienden urgencias reales?",
      a: "Sí. ante una urgencia, comunícate de inmediato con nuestro equipo. Realizaremos una teleorientación inicial para evaluar la situación y ayudarte a tomar la mejor decisión para tu mascota, indicándote el tipo de atención o el centro veterinario adecuado según el caso.",
    },
    //{
    //  q: "¿Petfam funciona en toda Latinoamérica?",
    //  a: "Contamos con red de aliados en varios países de la región y seguimos creciendo. Escríbenos por WhatsApp para confirmar cobertura en tu ciudad.",
    //},
  ];

  return (
    <>
      {/* ============ HEADER ============ */}
      <header className="pf-header">
        <div className="pf-header-inner">
          <Link to="/" className="pf-brand" aria-label="Petfam — Inicio">
            <PetfamLogo className="pf-logo" aria-hidden="true" />
          </Link>

          <nav className={`pf-nav ${navOpen ? "is-open" : ""}`}>
            <Link
              to="/"
              className={`pf-nav-pill ${activeNav === "inicio" ? "is-active" : ""}`}
              onClick={() => handleNavClick("inicio")}
            >
              Inicio
            </Link>
            <a
              href="#servicios"
              className={`pf-nav-link ${activeNav === "servicios" ? "is-active" : ""}`}
              onClick={() => handleNavClick("servicios")}
            >
              Servicios
            </a>
            <a
              href="#como-funciona"
              className={`pf-nav-link ${activeNav === "como-funciona" ? "is-active" : ""}`}
              onClick={() => handleNavClick("como-funciona")}
            >
              Cómo funciona
            </a>
            <a
              href="#historias"
              className={`pf-nav-link ${activeNav === "historias" ? "is-active" : ""}`}
              onClick={() => handleNavClick("historias")}
            >
              Historias
            </a>
            <a
              href="#preguntas"
              className={`pf-nav-link ${activeNav === "preguntas" ? "is-active" : ""}`}
              onClick={() => handleNavClick("preguntas")}
            >
              Preguntas
            </a>

            <div className="pf-nav-auth">
              {!isMobileOrTablet && (
                <Link to="/login" state={{ from: "home" }} className="pf-link-plain" onClick={() => setNavOpen(false)}>
                  Iniciar sesión
                </Link>
              )}
              <Link to="/crear-cuenta" state={{ from: "home" }} className="pf-btn pf-btn-dark pf-btn-header pf-btn-header-desktop" onClick={() => setNavOpen(false)}>
                Suscribirse <span aria-hidden="true">→</span>
              </Link>
            </div>
          </nav>

          <div className="pf-header-mobile-actions">
            <button
              className={`pf-burger ${navOpen ? "is-open" : ""}`}
              onClick={() => setNavOpen((v) => !v)}
              aria-label="Abrir menú"
              aria-expanded={navOpen}
            >
              <span /><span /><span />
            </button>

            <Link to="/login" state={{ from: "home" }} className="pf-btn pf-btn-dark pf-btn-header pf-btn-header-mobile" onClick={() => setNavOpen(false)}>
              Iniciar sesión <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </header>

      {/* ============ HERO ============ */}
      <section className="pf-hero">
        <div className="pf-hero-grid">
          <div className="pf-hero-copy fade-in">
            <h1 className="pf-h1">
              Porque no es solo una <span className="pf-accent">mascota</span>, es parte de tu
              <br />
              <span className="pf-accent pf-accent-strong">familia</span>.
            </h1>

            <p className="pf-lead">
              Veterinarios 24/7, urgencias, historia clínica digital y un auxilio económico
              de <strong>$800.000 por evento.</strong> Todo en una sola membresía, sin copagos ni letra pequeña.
            </p>

            <div className="pf-hero-buttons bounce-in">
              <Link to="/crear-cuenta" state={{ from: "home" }} className="pf-btn pf-btn-teal">
                Suscríbete por ${formatCOP(PLAN_PRICE_COP)} <span aria-hidden="true">→</span>
              </Link>
              <a href="#servicios" className="pf-btn pf-btn-ghost">
                Ver todos los beneficios
              </a>
            </div>

            <div className="pf-hero-stats">
              <div><strong>24/7</strong><span>Veterinarios reales</span></div>
              <div><strong>$800K</strong><span>Auxilio por evento</span></div>
              <div><strong>2</strong><span>Mascotas por perfil</span></div>
              <div><strong>+30</strong><span>Aliados con descuentos</span></div>
            </div>
          </div>

          <div className="pf-hero-media zoom-in">
            <div className="pf-hero-circle">
              <img src={background} alt="Veterinario revisando a un cachorro" loading="lazy" />
            </div>
            <div className="pf-float pf-float-top">
              <IconPhone /> Vet en línea 24/7
            </div>
            <div className="pf-float pf-float-bottom">
              <span className="pf-float-icon"><IconShield /></span>
              <span>
                <strong>Auxilio $800.000</strong>
                <em>Sin límite de eventos</em>
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ============ SOMOS PETFAM ============ */}
      <section className="pf-somos">
        <div className="pf-somos-grid">
          <div className="fade-in">
            <span className="pf-eyebrow">Quiénes somos</span>
            <h2 className="pf-h2">Hola, somos Petfam.</h2>
            <p className="pf-body">
              Ofrecemos servicios integrales de salud, bienestar y acompañamiento para mascotas
              y sus familias. Combinamos tecnología y expertos en cada paso de su vida. Nada de
              trámites ni paquetes sueltos: todo lo que tu mascota necesita, cuando lo necesita.
            </p>

            <ul className="pf-checklist pf-checklist-grid">
              <li>✓ Veterinarios certificados</li>
              <li>✓ Etólogos especializados</li>
              <li>✓ Red de aliados en toda Colombia</li>
              <li>✓ Plataforma 100% digital</li>
            </ul>
          </div>

          <div className="pf-somos-media zoom-in">
            <img src={heroServicios} alt="Perro y gato Petfam" className="pf-somos-img" loading="lazy" decoding="async" />
          </div>
        </div>

        <svg className="pf-somos-curve" viewBox="0 0 1440 50" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0,8 C420,50 760,0 1440,18 L1440,50 L0,50 Z" fill="#F7E4D0" />
        </svg>
      </section>

      {/* ============ PLAN ============ */}
      <section className="pf-plan">
        <div className="pf-plan-inner">
        <div className="pf-plan-head fade-in">
          <span className="pf-eyebrow">Un solo plan, todo incluido</span>
          <h2 className="pf-plan-title">Todo lo que necesitas para cuidar la salud de tu mascota</h2>
        </div>
        <p className="pf-plan-desc">Por menos de lo que cuesta una consulta veterinaria, cuidamos a tu mascota todo el mes.</p>

        <div className="pf-plan-cards">
          <div className="pf-plan-card bounce-in">
            <div className="pf-plan-price">
              <span className="pf-plan-old-price">$24.900</span>
              <span className="pf-plan-amount">$19.900</span>
              <span className="pf-plan-period">COP/mes</span>
            </div>

            <ul className="pf-plan-includes">
              {planIncludes.map((item) => (
                <li key={item}><span className="pf-check pf-check-teal">✓</span> {item}</li>
              ))}
            </ul>

            <Link to="/crear-cuenta" state={{ from: "home" }} className="pf-btn pf-btn-teal pf-btn-block">
              Suscribirse ahora <span aria-hidden="true">→</span>
            </Link>
          </div>

          <div className="pf-plan-card pf-plan-card-dark bounce-in">
            <span className="pf-tag">Beneficio estrella</span>
            <h3 className="pf-plan-benefit-title">Auxilio económico de $800.000 por evento</h3>
            <p>
              Ante una urgencia, accidente o enfermedad, cubrimos hasta <strong>$800.000 COP</strong> por
              cada evento. <strong>Sin límite de eventos</strong> al año — porque los imprevistos no avisan.
            </p>
            <ul className="pf-checklist pf-checklist-light">
              <li><span className="pf-check pf-check-gold">✓</span> Urgencias veterinarias reales</li>
              <li><span className="pf-check pf-check-gold">✓</span> Sin trámites eternos</li>
              <li><span className="pf-check pf-check-gold">✓</span> Válido en todas las clínicas</li>
              <li><span className="pf-check pf-check-gold">✓</span> Se activa desde el segundo mes</li>
            </ul>
            <IconShield />
          </div>
        </div>
        </div>
      </section>

      {/* ============ SERVICIOS ============ */}
      <section className="pf-services" id="servicios">
        <div className="pf-services-head fade-in">
          <div>
            <span className="pf-eyebrow">Servicios</span>
            <h2 className="pf-h2">
              Conoce nuestros <span className="pf-accent">servicios</span>
            </h2>
          </div>
          <p className="pf-body">Todo lo que tu mascota necesita para vivir sana, feliz y protegida — en una sola plataforma.</p>
        </div>

        <div className="pf-services-grid zoom-in">
          {services.map((s) => (
            <div className={`pf-service-card pf-tone-${s.tone}`} key={s.title}>
              <span className="pf-service-icon">{s.icon}</span>
              <h4>{s.title}</h4>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ============ CÓMO FUNCIONA ============ */}
      <section className="pf-how" id="como-funciona">
        <div className="pf-how-grid">
          <div className="pf-how-media zoom-in">
            <div className="pf-phone-mockup">
              <span className="pf-phone-notch" aria-hidden="true"></span>
              <div className="pf-phone-screen">
                <video src="/videos/app-demo.mp4" autoPlay loop muted playsInline aria-label="Demostración de la app Petfam" />
              </div>
            </div>
          </div>

          <div className="fade-in">
            <span className="pf-eyebrow">Así funciona</span>
            <h2 className="pf-how-title">Empieza a cuidar a tu mascota en 2 pasos.</h2>

            <ol className="pf-steps">
              <li>
                <span className="pf-step-n">01</span>
                <div>
                  <h4>Activa tu suscripción</h4>
                  <p>Desde ${formatCOP(PLAN_PRICE_COP)}/mes. Sin permanencia. Cancelas cuando quieras.</p>
                </div>
              </li>
              <li>
                <span className="pf-step-n">02</span>
                <div>
                  <h4>Crea tu perfil</h4>
                  <p>Registra a tu mascota (hasta 2 por cuenta) con sus datos básicos. Toma menos de 3 minutos.</p>
                </div>
              </li>
            </ol>

            <p className="pf-how-done">¡Y listo! Ya puedes disfrutar de todo lo que te ofrece nuestra plataforma.</p>

            <div className="pf-hero-buttons bounce-in">
              <Link to="/crear-cuenta" state={{ from: "home" }} className="pf-btn pf-btn-teal">Suscribirse <span aria-hidden="true">→</span></Link>
            </div>
          </div>
        </div>
      </section>

      {/* ============ HISTORIAS / TESTIMONIOS ============ */}
      <section className="pf-testimonials" id="historias">
        <div className="pf-testimonials-head fade-in">
          <span className="pf-eyebrow">Historias</span>
          <h2 className="pf-h2">La experiencia de nuestros usuarios</h2>
          <p className="pf-body">Miles de familias en Colombia ya cuidan a sus mascotas con Petfam.</p>
        </div>

        {!isMobileOrTablet && (
          <div className="pf-testimonials-grid fade-in">
            {testimonials.map((t) => (
              <div className="pf-t-card" key={t.title}>
                <Stars />
                <h4>{t.title}</h4>
                <p>“{t.quote}”</p>
                <span className="pf-t-author">{t.who}</span>
              </div>
            ))}
          </div>
        )}

        {isMobileOrTablet && (
          <div className="pf-testimonials-mobile fade-in">
            <div key={activeTestimonial} className="pf-t-card pf-t-animate">
              <Stars />
              <h4>{testimonials[activeTestimonial].title}</h4>
              <p>“{testimonials[activeTestimonial].quote}”</p>
              <span className="pf-t-author">{testimonials[activeTestimonial].who}</span>
            </div>
            <div className="pf-mobile-nav">
              <div className="pf-dots" role="tablist" aria-label="Testimonios">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    type="button"
                    className={`pf-dot ${activeTestimonial === i ? "is-active" : ""}`}
                    onClick={() => setActiveTestimonial(i)}
                    aria-label={`Ver testimonio ${i + 1}`}
                  />
                ))}
              </div>
              <button type="button" className="pf-next" onClick={() => setActiveTestimonial((p) => (p + 1) % testimonials.length)} aria-label="Siguiente testimonio">→</button>
            </div>
          </div>
        )}
      </section>

      {/* ============ PREGUNTAS FRECUENTES ============ */}
      <section className="pf-faq" id="preguntas">
        <div className="pf-faq-inner">
        <div className="pf-faq-head fade-in">
          <span className="pf-eyebrow">Preguntas frecuentes</span>
          <h2 className="pf-h2">Resolvemos tus dudas</h2>
        </div>

        <div className="pf-faq-list fade-in">
          {faqs.map((item, i) => {
            const open = openFaq === i;
            return (
              <div className={`pf-faq-item ${open ? "is-open" : ""}`} key={item.q}>
                <button
                  className="pf-faq-question"
                  onClick={() => setOpenFaq(open ? -1 : i)}
                  aria-expanded={open}
                >
                  {item.q}
                  <IconPlus open={open} />
                </button>
                {open && <p className="pf-faq-answer">{item.a}</p>}
              </div>
            );
          })}
        </div>
        </div>
      </section>

      {/* ============ CTA FINAL ============ */}
      <section className="pf-cta">
        <div className="pf-cta-card zoom-in">
          <span className="pf-tag pf-tag-light">Empieza hoy</span>
          <h2 className="pf-h2 pf-h2-light">Tu mascota merece el mejor cuidado.</h2>
          <p>
            Suscríbete por ${formatCOP(PLAN_PRICE_COP)} al mes, cubre hasta 2 mascotas y activa el
            auxilio de $800.000 por evento desde el segundo mes.
          </p>
          <div className="pf-hero-buttons">
            <Link to="/crear-cuenta" state={{ from: "home" }} className="pf-btn pf-btn-peach">
              Suscribirse por ${formatCOP(PLAN_PRICE_COP)} <span aria-hidden="true">→</span>
            </Link>
            <Link to="/login" state={{ from: "home" }} className="pf-btn pf-btn-outline-light">
              Iniciar sesión
            </Link>
          </div>
          <svg className="pf-cta-deco" viewBox="0 0 200 200" aria-hidden="true">
            <ellipse cx="148" cy="150" rx="32" ry="25" fill="none" stroke="currentColor" strokeWidth="1.2" />
            <circle cx="103" cy="123" r="11" fill="none" stroke="currentColor" strokeWidth="1.2" />
            <circle cx="128" cy="98" r="12" fill="none" stroke="currentColor" strokeWidth="1.2" />
            <circle cx="162" cy="96" r="12" fill="none" stroke="currentColor" strokeWidth="1.2" />
            <circle cx="188" cy="115" r="10" fill="none" stroke="currentColor" strokeWidth="1.2" />
          </svg>
        </div>
      </section>

      {/* ============ FOOTER ============ */}
      <footer className="pf-footer">
        <div className="pf-footer-grid">
          <div className="pf-footer-brand">
            <Link to="/" className="pf-brand pf-brand-light">
              <PetfamLogo className="pf-logo" aria-hidden="true" />
              <span>petfam</span>
            </Link>
            <p>La plataforma de cuidado integral para mascotas en Latinoamérica. Porque no es solo una mascota, es familia.</p>
          </div>

          <div>
            <h5>Producto</h5>
            <ul>
              <li><a href="#servicios">Servicios</a></li>
              <li><a href="#como-funciona">Cómo funciona</a></li>
              <li><a href="#preguntas">Preguntas</a></li>
            </ul>
          </div>

          <div>
            <h5>Contacto</h5>
            <ul className="pf-footer-contact">
              <li>WhatsApp 24/7</li>
              <li>soporte@petfam.club</li>
              <li>Cali · Colombia</li>
            </ul>
          </div>
        </div>

        <div className="pf-footer-legal">
          <p>© 2025. Petfam — Vetia S.A.S.</p>
          <ul>
            <li><Link to="/terminos" state={{ transition: "down" }}>Términos y condiciones</Link></li>
            <li><Link to="/privacidad" state={{ transition: "down" }}>Política de privacidad</Link></li>
            <li><Link to="/reembolsos" state={{ transition: "down" }}>Política de reembolsos</Link></li>
          </ul>
        </div>
      </footer>
    </>
  );
};

export default Home;